{
  "open": "Ассистент",
  "openUnread": "Ассистент: новых ответов — {{n}}",
  "openWaiting": "Ассистент: ждут вашего решения — {{n}}",
  "title": "Ассистент",
  "close": "Закрыть",
  "expand": "Развернуть",
  "collapse": "Свернуть",
  "back": "К разговорам",
  "resize": "Ширина панели ассистента",
  "loading": "Загружаю разговор…",
  "thinking": "Думаю…",
  "readOnly": "Только чтение",
  "mode": {
    "change": "Изменения разрешены ещё {{hours}}\u00a0ч {{minutes}}\u00a0мин",
    "changeMinutes": "Изменения разрешены ещё {{minutes}}\u00a0мин",
    "changeShort": "{{hours}}\u00a0ч {{minutes}}\u00a0мин",
    "changeMinutesShort": "{{minutes}}\u00a0мин"
  },
  "cards": {
    "label": "Изменение: {{title}}",
    "where": "Проект: {{project}}",
    "target": "{{target}}",
    "risk": {
      "operate": "Риск: управление",
      "change": "Риск: изменение",
      "create": "Риск: создание",
      "destroy": "Риск: удаление",
      "dangerous": "Опасная команда",
      "destructive": "Удаляет или меняет"
    },
    "cost": "≈ {{monthly}} {{currency}} в месяц, до конца месяца {{toMonthEnd}} {{currency}}",
    "budget": {
      "blocked_new": "Бюджет проекта ({{budget}} {{currency}}) достигнут: новую платную услугу панель не создаст.",
      "blocked_change": "Изменение выведет прогноз за бюджет с запасом ({{limit}} {{currency}}): панель его отклонит.",
      "raise": "Запросить увеличение бюджета",
      "adminWarning": "Это выйдет за бюджет проекта. Как администратор вы можете выполнить это всё равно; превышение попадёт в журнал."
    },
    "interrupts": {
      "restart": "Сервер перезагрузится.",
      "power_off": "Сервер выключится.",
      "needs_off": "Сработает только на выключенном сервере.",
      "disk_overwritten": "Всё на диске сервера будет заменено.",
      "traffic": "Соединения могут прерваться.",
      "data_loss": "Удаляется безвозвратно."
    },
    "warnings": {
      "systemctl_restart": "Пока сервис перезапускается, он недоступен.",
      "systemctl_reload": "Сервис перечитает настройки; с ошибкой в них он может остановиться.",
      "systemctl_start": "Сервис запустится и может открыть порты.",
      "systemctl_stop": "Сервис будет остановлен, пока его не запустят снова.",
      "docker_restart": "Контейнер перезапустится, его соединения оборвутся.",
      "packages_upgrade_security": "Ставятся только обновления безопасности (не полное обновление), от root; сервисы, которые их используют, могут перезапуститься.",
      "package_install": "Программа ставится от root из репозиториев дистрибутива.",
      "firewall_allow": "Порт станет доступен из интернета (если его пропускает и облачный файрвол).",
      "firewall_deny": "Подключения к порту будут отклоняться.",
      "nginx_test_reload": "nginx перечитает настройки, только если проверка конфигурации прошла.",
      "logrotate_force": "Логи будут ротированы сейчас."
    },
    "role": "Роль Автопилота на сервере: {{role}}",
    "details": "Подробнее",
    "typeName": "Чтобы удалить, введите «{{name}}»",
    "stepUp": "Подтвердите вторым фактором: изменения через ассистента будут разрешены в этом браузере на {{hours}}\u00a0ч или до выхода. Каждое изменение по-прежнему ждёт вашей кнопки.",
    "stepUpEvery": "В вашей организации каждое изменение подтверждается вторым фактором.",
    "cancel": "Отмена",
    "otherSession": "Подтвердить можно только в браузере, где карточка появилась.",
    "reject": "Отклонить",
    "run": "Выполнить",
    "running": "Выполняю…",
    "done": "Выполнено.",
    "operation": "Операция запущена; прогресс — в журнале операций проекта.",
    "failed": "Не выполнено.",
    "rejected": "Отклонено. Ничего не выполнялось.",
    "expired": "Карточка истекла. Ничего не выполнялось.",
    "terminalLabel": "Команда для терминала на {{server}}",
    "terminalLead": "Эту команду ассистент не выполняет: вставьте её в свой терминал на {{server}} (без Enter) или скопируйте — прочитайте и запустите сами.",
    "terminalClosed": "Чтобы вставить команду, откройте терминал на {{server}}.",
    "terminalWhere": "В вашем терминале {{name}}",
    "terminalWrite": "Команда меняет систему: ассистент наберёт её в вашем терминале, когда вы нажмёте «Выполнить».",
    "terminalDangerous": "Опасная команда: она может удалить данные, отрезать доступ к серверу или остановить его. Подтвердите вторым фактором.",
    "terminalDestructive": "Команда удаляет, перезаписывает, останавливает или заметно меняет систему: ассистент наберёт её в вашем терминале, только когда вы нажмёте «Выполнить» — даже в режиме «Авто».",
    "effect": "Что будет удалено или изменено: {{effect}}",
    "stepUpDangerous": "Опасная команда подтверждается вторым фактором — для этой карточки отдельно."
  },
  "newAbout": "Новый разговор о {{name}}",
  "newConversation": "Новый разговор",
  "organization": "Вся организация",
  "retention": "Разговоры видите только вы; они хранятся 90 дней после последнего сообщения.",
  "today": "сегодня {{used}} из {{limit}} сообщений",
  "injection": "В данных сервера был текст с инструкциями для ИИ — я их не выполнял.",
  "stopped": "Остановлено",
  "copy": "Скопировать",
  "copied": "Скопировано",
  "ask": {
    "button": "Спросить ассистента",
    "aboutRule": "Спросить ассистента об этом правиле",
    "error": "Что значит эта ошибка и как её исправить?",
    "operation": "Почему эта операция не удалась и что делать?",
    "alert": "Что означало это оповещение и было ли что-то не так?",
    "alertFiring": "Почему сработало это оповещение и как это исправить?",
    "firewallRule": "Что разрешает это правило и безопасно ли оно?",
    "selectionName": "Выделенное в терминале {{server}}"
  },
  "server": {
    "button": "Ассистент",
    "open": "Спросить ассистента об этом сервере",
    "withCount": "Ассистент: разговоров об этом сервере — {{count}}"
  },
  "screen": {
    "chip": {
      "terminal": "Терминал {{server}}",
      "console": "Консоль {{server}}",
      "desktop": "Рабочий стол {{server}}"
    },
    "sent": "Снимок экрана в момент отправки сообщения",
    "newLines": "{{name}} · новые строки"
  },
  "offer": {
    "switchTo": "Перейти в разговор о {{name}}",
    "newAbout": "Новый разговор о {{name}}"
  },
  "attach": {
    "button": "Приложить лог или скриншот",
    "pending": "Уйдёт вместе с сообщением",
    "sent": "Приложено",
    "pasted": "Вставленный текст",
    "uploading": "Загружаю…",
    "remove": "Убрать «{{name}}»",
    "injection": "Во вложении был текст с инструкциями для ИИ — ассистент их не выполняет."
  },
  "operator": {
    "title": "Использование установки за {{month}}",
    "lead": "Все организации этой установки; вы видите это как её оператор.",
    "limit": "{{used}} из {{limit}} токенов за месяц ({{percent}}\u00a0%).",
    "noLimit": "{{used}} токенов за месяц; месячного лимита у установки нет.",
    "empty": "В этом месяце ассистентом никто не пользовался.",
    "organization": "Организация",
    "people": "Людей"
  },
  "chips": {
    "error": "Ошибка: {{label}}"
  },
  "switcher": {
    "title": "Разговоры",
    "search": "Найти разговор",
    "new": "Новый разговор",
    "all": "Все разговоры →",
    "thinking": "думает…",
    "waiting": "ждёт вас",
    "unread": "Новый ответ",
    "empty": "Разговоров пока нет",
    "about": "О {{name}}",
    "clearFilter": "Показать все разговоры"
  },
  "list": {
    "rename": "Название разговора",
    "renameThis": "Переименовать «{{title}}»",
    "save": "Сохранить название",
    "delete": "Удалить",
    "deleteThis": "Удалить «{{title}}»",
    "deleteTitle": "Удалить разговор «{{title}}»?",
    "deleteConsequence": "Тексты разговора удалятся; журнал аудита того, что смотрел ассистент, останется."
  },
  "empty": {
    "lead": "Я вижу ресурсы ваших проектов с вашими правами. Изменения предлагаю карточкой — выполняются они, только когда вы нажмёте «Выполнить». Спрашивайте про панель, Linux, сети, Docker, базы данных и код."
  },
  "suggestions": {
    "label": "С чего начать",
    "serverDown": "Почему сервер не отвечает?",
    "serverLoad": "Чем занят сервер — процессор, диск, сеть?",
    "openPort": "Как открыть порт 443?",
    "monthCost": "Сколько я потрачу в этом месяце?",
    "cheaper": "Где можно сэкономить?",
    "budget": "Хватит ли бюджета до конца месяца?",
    "firewallCheck": "Какие порты открыты этим файрволом?",
    "sshOnly": "Как пускать SSH только с моего адреса?",
    "privateNetwork": "Как подключить сервер к приватной сети?",
    "balancer502": "Почему балансировщик отдаёт 502?"
  },
  "composer": {
    "label": "Сообщение ассистенту",
    "placeholder": "Спросите про серверы, сети, расходы…",
    "send": "Отправить",
    "stop": "Остановить ответ",
    "hint": "Enter — отправить, Shift+Enter — новая строка",
    "mistakes": "Автопилот может допускать ошибки."
  },
  "refusal": {
    "out_of_scope": "Вне темы",
    "disallowed": "Не помогаю с этим",
    "model": "Модель отказалась"
  },
  "tool": {
    "get": "Посмотрел {{what}} {{target}}",
    "list": "Посмотрел: {{what}}",
    "help": "Поискал в справке: «{{query}}»",
    "proposal": "Подготовил изменение для вашего подтверждения",
    "explain": "Посмотрел ошибку «{{reason}}»",
    "estimate": "Посчитал стоимость изменения",
    "error": "не вышло",
    "denied": "нет доступа",
    "request": "Запрос ({{tool}})",
    "result": "Ответ",
    "load": "Взял инструменты: {{what}}",
    "pair": "Выполнил в терминале {{target}}: {{command}}",
    "pairRunning": "Выполняет в терминале: {{command}}",
    "pairRefused": "Не набрал в терминале: {{command}}"
  },
  "groups": {
    "servers": "сервер",
    "networks": "сеть",
    "firewalls": "файрвол",
    "volumes": "тома",
    "load_balancers": "балансировщик",
    "certificates": "сертификаты",
    "floating_ips": "плавающие IP",
    "public_ips": "публичные IP",
    "placement_groups": "группы размещения",
    "images": "снимки и бэкапы",
    "ssh_keys": "SSH-ключи",
    "costs": "расходы",
    "budgets": "бюджет",
    "alerts": "алерты",
    "autopilot": "Автопилот",
    "operations": "операции",
    "activities": "журнал",
    "catalogue": "каталог",
    "projects": "проекты",
    "notifications": "уведомления",
    "terminal": "терминал",
    "errors": "ошибки",
    "resources": "ресурсы"
  },
  "setup": {
    "title": "Включить ассистента",
    "lead": "Ассистент отвечает на вопросы про серверы, инфраструктуру и разработку и смотрит ресурсы проектов с правами того, кто спрашивает. Перед включением примите уведомление о данных:",
    "notice": {
      "sent": "Провайдеру модели (Anthropic) уходят сообщения, контекст страницы и результаты инструментов.",
      "provider": "Провайдер обрабатывает их по своим условиям API.",
      "redacted": "Пароли, ключи и токены скрываются до отправки; учётные данные к модели не попадают никогда.",
      "kept": "Разговоры видит только их автор; мы храним их 90 дней после последнего сообщения. Администраторы видят использование и журнал аудита, но не тексты."
    },
    "accept": "Принять и включить"
  },
  "settings": {
    "title": "Настройки ассистента",
    "open": "Настройки ассистента",
    "back": "К разговору",
    "enabled": "Ассистент включён",
    "projects": "Где работает",
    "allProjects": "Во всех проектах",
    "perMinute": "Сообщений в минуту на человека",
    "perDay": "Сообщений в день на человека",
    "tokensPerDay": "Токенов в день на человека",
    "monthly": "Токенов в месяц на организацию",
    "monthlyHint": "Пусто — без своего лимита",
    "notice": "Уведомление о данных принято {{date}}",
    "models": "Модели: {{chat}} (сложное), {{fast}} (простое), фильтр тем — {{filter}}",
    "save": "Сохранить",
    "saved": "Сохранено",
    "usage": "Использование за {{month}}",
    "costHint": "Оценка в евро по прайс-листу провайдера; ничего не списывается.",
    "noUsage": "В этом месяце ассистентом не пользовались.",
    "person": "Человек",
    "messages": "Сообщения",
    "tokens": "Токены",
    "cost": "Оценка",
    "total": "Всего",
    "changes": "Изменения через ассистента",
    "allowChanges": "Разрешить изменения с карточек подтверждения",
    "windowHours": "На сколько часов второй фактор разрешает изменения",
    "windowHint": "От 1 до 12 часов; выход из панели заканчивает их сразу.",
    "stepUpEveryChange": "Спрашивать второй фактор на каждое изменение",
    "style": "Стиль ответов по умолчанию",
    "styleHint": {
      "brief": "До 5–7 строк: суть и действие сначала, подробности — по просьбе.",
      "standard": "Обычная длина: суть, затем шаги и причины."
    },
    "styleOwn": "Это значение по умолчанию; каждый может выбрать своё в своих настройках ассистента.",
    "model": "Модель",
    "modelMode": {
      "auto": "Авто",
      "economy": "Экономно",
      "quality": "Качество"
    },
    "modelHint": {
      "auto": "{{fast}} для простых ответов, {{chat}} — для изменений, скриншотов и диагностики.",
      "economy": "Всегда {{fast}}: дешевле, но слабее в сложных вопросах.",
      "quality": "Всегда {{chat}}: дороже."
    },
    "byModel": "Использование по моделям",
    "modelColumn": "Модель",
    "answers": "Ответы",
    "terminalMax": "Наибольший доступ Автопилота к терминалу",
    "terminalMaxHint": "Каждый сам выбирает доступ Автопилота к своему терминалу, со вторым фактором, — не выше этого уровня. «Выключено» запрещает работу в терминалах всей организации; понижение сразу опускает открытые сеансы.",
    "mine": "Мои настройки",
    "organization": "Организация",
    "terminalDefault": "Доступ Автопилота к новым терминалам",
    "panelDefault": "Действия в панели по умолчанию",
    "panelDefaultHint": {
      "read": "После каждого изменения с карточки — снова только чтение: следующее спросит второй фактор.",
      "change": "Второй фактор разрешает изменения с карточек на {{hours}}\u00a0ч."
    },
    "hints": "Показывать подсказки",
    "voice": "Голосовой ввод",
    "voiceHint": "Кнопка микрофона в поле ввода. Речь распознаёт браузер (звук уходит в Google или Apple); текст попадает в поле и сам не отправляется.",
    "voiceUnsupported": "Этот браузер не распознаёт речь — кнопки микрофона не будет."
  },
  "command": {
    "insert": "Вставить в терминал",
    "insertHint": "Вставить в {{name}} без Enter — прочитайте и запустите сами",
    "run": "Выполнить в терминале",
    "runHint": "Попросить Автопилот выполнить в {{name}}",
    "runAsk": "Выполни в терминале:\n```\n{{command}}\n```",
    "runEvent": "▶ Запуск по кнопке: {{command}}",
    "noTerminal": "Откройте терминал сервера",
    "busy": "Дождитесь конца ответа",
    "runAccess": "Дать Автопилоту доступ к {{name}} и выполнить",
    "raiseFirst": "У Автопилота нет доступа к этому терминалу. Выберите уровень — команда выполнится сразу после этого."
  },
  "focus": {
    "switched": "Перешли с {{from}} на {{to}}"
  },
  "style": {
    "label": "Стиль ответов",
    "brief": "Кратко",
    "standard": "Стандартно"
  },
  "toolGroups": {
    "servers": "серверы",
    "network": "сети и балансировщики",
    "firewalls": "файрволы",
    "storage": "тома и снимки",
    "ips": "IP-адреса",
    "costs": "расходы и бюджет",
    "autopilot": "Автопилот",
    "alerts": "алерты",
    "access": "ключи",
    "operations": "операции",
    "other": "остальное"
  },
  "pair": {
    "running": "Автопилот выполняет: {{command}}",
    "stop": "Стоп",
    "stopLabel": "Остановить Автопилот в терминале {{name}}"
  },
  "access": {
    "title": "Доступ Автопилота к терминалу",
    "label": "Доступ Автопилота к терминалу: {{target}} · {{level}}",
    "labelNone": "Доступ Автопилота к терминалу: нет открытого терминала",
    "noTerminal": "Нет открытого терминала",
    "noTerminalHint": "Откройте терминал (SSH) к серверу этого проекта, чтобы дать Автопилоту доступ. Без него чат работает с данными панели.",
    "pairOff": "Работа в терминале выключена для организации или проекта",
    "aboveMax": "Выше, чем разрешает организация",
    "levels": {
      "off": "Выключено",
      "read": "Только чтение",
      "moderated": "Модерация изменений",
      "auto": "Авто"
    },
    "hints": {
      "off": "Автопилот не видит этот терминал и ничего в нём не набирает.",
      "read": "Видит экран и выделенное; сам выполняет только команды, которые ничего не меняют.",
      "moderated": "Смотрит сам; команды, которые меняют систему, — только после вашей кнопки на карточке.",
      "auto": "Сам ставит пакеты, перезапускает службы, создаёт файлы; всё, что удаляет, перезаписывает или останавливает, ждёт вашей кнопки, опасное — ещё и второго фактора."
    },
    "intro": "Здесь вы решаете, что Автопилот может делать в открытом терминале, — от «Выключено» до «Авто». Уровень действует для этого сеанса; включение подтверждается вторым фактором. Ниже — действия в панели: только чтение или изменения на время после второго фактора.",
    "introDone": "Понятно",
    "panel": "Действия в панели",
    "changes": "Изменения",
    "changesOff": "Организация не разрешает изменения через ассистента",
    "panelHints": {
      "read": "Ассистент смотрит с вашими правами; изменение предлагает карточкой.",
      "change": "Второй фактор разрешает изменения с карточек на время; каждое по-прежнему ждёт вашей кнопки."
    },
    "short": {
      "off": "Выкл.",
      "read": "Чтение",
      "moderated": "Модерация",
      "auto": "Авто"
    },
    "noTerminalShort": "Нет терминала"
  },
  "quote": {
    "label": "Выделенное в терминале {{server}} (строк: {{count}}) уйдёт с сообщением",
    "remove": "Не отправлять выделенное"
  },
  "nearLimit": "Сообщений на сегодня осталось: {{left}} из {{limit}}",
  "clouds": {
    "label": "Уйдёт с сообщением",
    "terminalScreen": "Терминал {{name}}: его экран и выделенное уйдут с сообщением",
    "session": "Сеанс {{name}}: Автопилот знает, о каком сервере речь",
    "page": "{{name}}: Автопилот знает, о чём страница",
    "selection": "Выделено, строк: {{count}}"
  },
  "voice": {
    "button": "Голосовой ввод",
    "recording": "Идёт запись — Esc или кнопка микрофона остановят её",
    "notice": "Распознавание речи выполняет браузер: звук уходит в Google или Apple",
    "noticeDone": "Понятно",
    "refused": "Браузер не дал доступ к микрофону"
  }
}
